import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// components
import Appointment from './_Appointment';
import AvailableDoctorsTooltip from './_AvailableDoctorsTooltip';
import FreeStandingAppointmentTooltip from './_FreeStandingAppointmentTooltip';

// lib
import formatDate from '../../../lib/formatDate';

class Day extends React.Component {
  static propTypes = {
    appointment:          PropTypes.instanceOf(Immutable.Map),
    date:                 PropTypes.instanceOf(moment),
    doctorAvailabilities: PropTypes.instanceOf(Immutable.Map)
  }
  constructor(props) {
    super(props);

    this.state = {
      data: Immutable.Map({ showAvailableDoctorsTooltip: false })
    };
  }

  render() {
    const { date } = this.props;

    return (
      <div className='calendar__day'>
        <div className='calendar__day__number'>{ date.format('D') }</div>

        { this._renderDetails() }
      </div>
    );
  }

  // private

  _renderDetails() {
    const { appointment, date, doctorAvailabilities, currentUser, appointmentError, loading, tooltip } = this.props;
    const elements           = [];
    const doctorAvailability = (doctorAvailabilities.get('data') || Immutable.Map()).get(date.format('YYYY-MM-DD')) || Immutable.Map();
    const appointmentData    = (appointment || Immutable.Map()).get('data') || Immutable.Map();
    const appointments       = (appointmentData.get(date.format('YYYY-MM-DD')) || Immutable.Map()).sort((a, b) => {
      const segmentA = a.get('segmentNumber');
      const segmentB = b.get('segmentNumber');

      let value = 0;

      if (segmentA < segmentB) {
        value = -1;
      } else if (segmentA > segmentB) {
        value = 1;
      }

      return value;
    });

    let element = null;

    if (date.day() !== 0 && date.day() !== 6) {
      appointments.forEach((a) => {
        elements.push(
          <Appointment appointment={ a } date={ date } key={ a.get('id') } loading={ appointment.get('loading') || false } />
        );
      });

      element = (
        <div>
          { elements }
          <FreeStandingAppointmentTooltip appointmentError={ appointmentError }
            currentUser={ currentUser }
            date={ date }
            id={ `freeStandingAppointmentTooltip${formatDate(date)}` }
            loading={ loading }
            tooltip={ tooltip } />
          <AvailableDoctorsTooltip date={ date }
            doctorAvailability={ doctorAvailability }
            id={ `availableDoctorsTooltip${formatDate(date)}` }
            loading={ doctorAvailabilities.get('loading') } />
        </div>
      );
    }

    return element;
  }
}

const mapStateToProps = (state) => {
  return {
    tooltip:              state.get('tooltip'),
    appointment:          state.get('appointment'),
    doctorAvailabilities: state.get('doctorAvailabilities'),
    currentUser:          state.get('currentUser'),
    appointmentError:     state.getIn(['appointment', 'error']),
    loading:              state.getIn(['appointment', 'loading'])
  };
};

export default connect(mapStateToProps)(Day);



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_Day.jsx